import React from 'react'

const navLinks = [
  { href: "/#what-we-do-logo-design", label: "Logo Design" },
  { href: "/#what-we-do-software-development", label: "Software Development" },
  { href: "/#what-we-do-web-design", label: "Website Development" },
  { href: "/#contact", label: "Contact Us" },
]

export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer style={{ fontFamily: "'Outfit', 'Poppins', sans-serif", background: "#0c0c10" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&family=Playfair+Display:ital,wght@0,700;1,400&display=swap');

        .footer-divider {
          width: 100%;
          height: 1px;
          background: #1e1e26;
        }

        .footer-tag {
          display: inline-block;
          font-size: 10px;
          font-weight: 600;
          letter-spacing: 0.15em;
          text-transform: uppercase;
          padding: 4px 12px;
          border: 1px solid #2a2a34;
          border-radius: 999px;
          color: #555;
        }

        .footer-nav-link {
          font-size: 13px;
          font-weight: 500;
          color: #666;
          text-decoration: none;
          letter-spacing: 0.01em;
          transition: color 0.2s;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .footer-nav-link:hover {
          color: #e0ddd8;
        }

        .footer-cta {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          text-decoration: none;
          color: #111;
          background: #e0ddd8;
          padding: 11px 22px;
          border-radius: 6px;
          transition: opacity 0.2s;
          font-family: 'Outfit', 'Poppins', sans-serif;
          white-space: nowrap;
        }

        .footer-cta:hover {
          opacity: 0.8;
        }
      `}</style>

      <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "64px 40px 40px" }}>

        {/* Top row */}
        <div style={{ display: "flex", flexDirection: "column", gap: "48px" }}>

          {/* Brand + CTA */}
          <div style={{ display: "flex", flexWrap: "wrap", alignItems: "flex-start", justifyContent: "space-between", gap: "32px" }}>

            <div style={{ maxWidth: "420px" }}>
              <p className="footer-tag" style={{ marginBottom: "20px" }}>Digital Agency</p>
              <img
                src="/Primary Logo-01.png"
                alt="KDPS"
                style={{ height: "52px", width: "auto", marginBottom: "20px", filter: "brightness(0) invert(1)", opacity: 0.9 }}
              />
              <p style={{ fontSize: "14px", color: "#555", lineHeight: 1.8 }}>
                A leading digital agency specializing in UI/UX design, mobile app & software development, website creation, and logo design. We bring your digital visions to life.
              </p>
            </div>

            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "16px" }}>
              <p style={{ fontSize: "10px", fontWeight: 600, letterSpacing: "0.15em", textTransform: "uppercase", color: "#444" }}>
                Start a project
              </p>
              <h3 style={{
                fontFamily: "'Playfair Display', Georgia, serif",
                fontWeight: 700,
                fontSize: "clamp(20px, 2.5vw, 28px)",
                color: "#e0ddd8",
                lineHeight: 1.2,
                maxWidth: "260px",
              }}>
                Ready to build something{" "}
                <span style={{ fontStyle: "italic", fontWeight: 400, color: "#555" }}>great?</span>
              </h3>
              <a href="/#contact" className="footer-cta">
                Get in touch
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M7 17L17 7M17 7H7M17 7v10" />
                </svg>
              </a>
            </div>

          </div>

          <div className="footer-divider" />

          {/* Bottom row */}
          <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "24px" }}>

            {/* Nav links */}
            <div style={{ display: "flex", flexWrap: "wrap", gap: "24px" }}>
              {navLinks.map(link => (
                <a key={link.href} href={link.href} className="footer-nav-link">
                  {link.label}
                </a>
              ))}
            </div>

          </div>

          <div className="footer-divider" />

          {/* Copyright */}
          <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "12px" }}>
            <p style={{ fontSize: "12px", color: "#3a3a44", letterSpacing: "0.02em" }}>
              © {currentYear} KDPS. All rights reserved.
            </p>
            <p style={{
              fontFamily: "'Playfair Display', Georgia, serif",
              fontStyle: "italic",
              fontSize: "12px",
              color: "#2e2e38",
            }}>
              Transforming ideas into digital realities
            </p>
          </div>

        </div>
      </div>
    </footer>
  )
}